import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class DisciplineList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      // user: {},
      // updated: false,
      // searched: false,
      loading: true
    };

    this.error = this.error.bind(this);
    this.insertDiscipline = this.insertDiscipline.bind(this);
    this.deleteDisciplines = this.deleteDisciplines.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  insertDiscipline() {
    this.props.history.push("/discipline/form");
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.handleDisciplines();
  }

  handleDisciplines() {
    axios
      .get(`${URL.api}classification/discipline/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.setState(
              () => ({
                list: null
              }),
              () => {
                if (resp.data.data.length === 0) {
                  this.setState(() => ({
                    list: [],
                    loading: false
                  }));
                } else {
                  this.setState(
                    () => ({
                      list: resp.data.data,
                      loading: false
                    }),
                    () => {
                      this.forceUpdate();
                    }
                  );
                }
              }
            );
          } else {
            this.props.logout(this.props.user.token);
          }
        },
        error => {
          this.error("Não foi possível listar as disciplinas");
        }
      );
  }

  deleteDisciplines(rows) {
    const obj = {
      disciplines: rows
    };

    axios
      .post(`${URL.api}classification/discipline/deleteMany`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.handleDisciplines();
        },
        () => {
          this.error("Não foi possível apagar as disciplinas");
        }
      );
  }

  render() {
    return (
      <div className="animated fadeIn">
        {this.state.loading ? (
          <Loading />
        ) : (
          <Row>
            <Breadcrumb current={this.props.currentRoute} />
            {this.state.list ? (
              <div id="list">
                <DataTable
                  list={this.state.list}
                  path="/discipline/edit/"
                  title="Disciplinas"
                  header={[
                    { name: "id", denomination: "ID" },
                    { name: "name", denomination: "Nome" },
                    { name: "abbreviation", denomination: "Abreviação" },
                    {
                      name: "learning_area_id",
                      denomination: "Área do conhecimento"
                    }
                  ]}
                  insert
                  delete
                  insertAction={this.insertDiscipline}
                  deleteAction={this.deleteDisciplines}
                />
              </div>
            ) : (
              <Loading />
            )}
          </Row>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DisciplineList);
